import { X, ArrowUpRight } from 'lucide-react';
import { UserTier, RateLimitError } from '../types/tier';
import { useEffect } from 'react';

interface UpgradeModalProps {
    isOpen: boolean;
    onClose: () => void;
    rateLimitError?: RateLimitError;
    currentTier?: UserTier;
}

export function UpgradeModal({ isOpen, onClose, rateLimitError }: UpgradeModalProps) {
    // Auto-dismiss after 8 seconds
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                onClose();
            }, 8000);
            return () => clearTimeout(timer);
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-2 duration-300">
            {/* Minimal Toast - Cursor/Kiro Style */}
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-3 pr-2 max-w-sm">
                <div className="flex items-start gap-3">
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 dark:text-white">
                            {rateLimitError?.message || 'Limit reached'}
                        </p>
                        {rateLimitError?.usage?.resetIn && (
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                Resets {rateLimitError.usage.resetIn}
                            </p>
                        )}
                        <a 
                            href="mailto:support@memtrail.app?subject=Upgrade%20Request"
                            className="inline-flex items-center gap-1 text-xs text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 mt-1.5"
                        >
                            Upgrade
                            <ArrowUpRight className="w-3 h-3" />
                        </a>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}

